import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";

import VuePrism from "vue-prism";
import "prismjs/themes/prism-okaidia.min.css";
import "prismjs/components/prism-json"; // Load JSON language

export default {
  name: "LogOverview",
  components: {
    VuePrism
  },
  props: ["logUrl"],
  data: () => ({
    logsFetched: false,
    logs: [],
    viewLog: -1
  }),
  async mounted() {
    if (!this.users.length) {
      await this.$store.dispatch("getAllUsers");
    }
  },
  computed: {
    users() {
      return this.$store.state.users;
    }
  },
  methods: {
    getUserName(user) {
      const foundUser = this.users.find(item => item._id === user);
      return `${foundUser.first_name} ${foundUser.last_name}`;
    },
    setViewLog(index) {
      if (this.viewLog === index) {
        this.viewLog = -1;
      } else {
        this.viewLog = index;
      }
    },
    async getLogs() {
      const headers = getTokenHeader();
      const response = await axios.get(this.logUrl, { headers });
      const data = response.data.data ?? response.data; // data.data because of auth service
      this.logs = data.map(log => ({
        isCreated: log.action === "create",
        isDeleted: log.action === "delete",
        changes: log.data.changes,
        updatedBy: this.getUserName(log.updatedBy),
        createdAt: log.createdAt.dateFormat()
      }));
      this.logsFetched = true;
      this.$nextTick(() => window.Prism.highlightAll());
    },
    resetLogs() {
      this.logsFetched = false;
      this.logs = [];
      this.viewLog = [];
    }
  }
};
